module.exports = __webpack_public_path__ + "img/white-and-grey-box-3248556.554b9ca8.jpg";